<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import vendorPaymentsApi from "@/api/resources/vendorPaymentsApi";
import VSelect from "@/components/ui/VSelect.vue";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
    paymentId: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getPaymentStatuses() {
      vendorPaymentsApi.transitionsIndex(this.paymentId).then((response) => {
        this.options = response.data.map((status) => {
          return { text: status.label, value: status.id };
        });
      });
    },
  },

  created() {
    this.getPaymentStatuses();
  },
};
</script>

<style></style>
